// extracted by mini-css-extract-plugin
export default {"container":"wgGsbC6OfKdTO6nfx8Qb","body":"pRGtGPtYIfdF3BNeZLiA"};